<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-card :loading="loading" :disabled="loading">
        <v-card-title class="indigo darken-3">
          <span class="grey--text text--lighten-4">
            {{ $t("menu.move_applicant") }}
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                outlined
                dense
                small
                label="เลขที่ผู้สมัคร"
                placeholder="* กรอกแล้วกด enter เพื่อดูข้อมูลเพิ่มเติม"
                v-model="register_id"
                @keyup.enter="get_register_details"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn
                dense
                elevation="0"
                color="orange lighten-2"
                @click="get_register_details"
              >
                ค้นหา
              </v-btn>
            </v-col>
          </v-row>
          <v-card v-if="UserInfo_nameTh" color="grey darken-4">
            <v-row>
              <v-col cols="12" md="12">
                <v-card-title class="text-h5">
                  <span class="amber--text lighten-1"
                    >ข้อมูลผู้สมัคร
                  </span></v-card-title
                >
                <v-card-subtitle>
                  <v-row>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF">ชื่อ :</span>
                      {{ UserInfo_nameTh + " " + UserInfo_surnameTh }}
                    </v-col>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF"
                        >Email :</span
                      >
                      {{ email }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF"
                        >เลขที่บัตรประชาชน :</span
                      >
                      {{ citizen }}
                    </v-col>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF">Tel. :</span>
                      {{ mobile }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF"
                        >ระดับ :</span
                      >
                      {{ register_level_name_th }}
                    </v-col>
                    <v-col cols="12" md="6" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF">รอบ :</span>
                      {{ register_round }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="white--text pt-4 mb-2">
                      <span style="font-size: 15px; color:#2979FF"
                        >โครงการ :</span
                      >
                      {{ register_project }}
                    </v-col>
                  </v-row>
                  <div class="holder">
                    <v-row class="d-flex flex-row-reverse">
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          label="สถานะใบสมัคร"
                          v-model="admissionStatus_id"
                          :item-text="(item) => item.MEANING_TH"
                          :items="admissionStatus"
                          :item-value="(item) => item.STATUS + item.REFUSE"
                          background-color="#E65100"
                          dark
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <!-- <h4 class="font-weight-light blue-grey--text text--lighten-5">
                    <span style="font-size: 15px; color:#2979FF">หลักสูตร</span>
                  </h4> -->
                    <v-row v-if="register_curriculum_name_order1">
                      <v-col cols="12" md="12">
                        <v-icon class="red--text">mdi-menu-right</v-icon>
                        ลำดับที่ 1
                        <span class="deep-orange--text">{{
                          register_curriculum_name_order1
                        }}</span>
                        {{ register_curriculum_detail_order1 }}
                      </v-col>
                    </v-row>
                    <v-row v-if="register_curriculum_name_order1">
                      <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                          label="สถานะ"
                          v-model="order1_status"
                          :item-text="(item) => item.name"
                          :items="curriculum_status"
                          :item-value="(item) => item.value"
                          dark
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="register_curriculum_name_order2">
                      <v-col cols="12" md="12">
                        <v-icon class="red--text">mdi-menu-right</v-icon>
                        ลำดับที่ 2
                        <span class="deep-orange--text">
                          {{ register_curriculum_name_order2 }}
                        </span>
                        {{ register_curriculum_detail_order2 }}
                      </v-col>
                    </v-row>
                    <v-row v-if="register_curriculum_name_order2">
                      <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                          label="สถานะ"
                          v-model="order2_status"
                          :item-text="(item) => item.name"
                          :items="curriculum_status"
                          :item-value="(item) => item.value"
                          dark
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row v-if="register_curriculum_name_order3">
                      <v-col cols="12" md="12">
                        <v-icon class="red--text">mdi-menu-right</v-icon>
                        ลำดับที่ 3
                        <span class="deep-orange--text">
                          {{ register_curriculum_name_order3 }}
                        </span>
                        {{ register_curriculum_detail_order3 }}
                      </v-col>
                    </v-row>
                    <v-row v-if="register_curriculum_name_order2">
                      <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                          label="สถานะ"
                          v-model="order3_status"
                          :item-text="(item) => item.name"
                          :items="curriculum_status"
                          :item-value="(item) => item.value"
                          dark
                          outlined
                          dense
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <div>
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-btn
                            dense
                            small
                            elevation="0"
                            color="light-blue lighten-2"
                            @click="save_status_curriculum_and_applicant()"
                          >
                            บันทึก
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </div>

                  <v-row class="white--text pt-4 mb-2">
                    <v-col cols="12" md="12">
                      project_id :
                      <span class="cyan--text darken-1">
                        {{ register_project_id_old }} </span
                      ><br />
                      admission_curriculum_id :
                      <span class="cyan--text darken-1">
                        {{ register_curriculum_id_old_order1 }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        background-color="blue-grey lighten-5"
                        outlined
                        dense
                        small
                        label="ค่ายืนยันสิทธิ์"
                        v-model="payment_confirm_fee"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-btn
                        color="yellow"
                        class="ml-5"
                        @click="save_assertion_fee()"
                      >
                        บันทึก
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>

        <v-card-text>
          <v-card v-if="UserInfo_nameTh">
            <v-card-title class="text-h5">
              <span class="deep-orange--text text--darken3 mb-5">
                ต้องการย้ายเลขที่สมัครนี้ไปที่
              </span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="level_id"
                    label="ระดับชั้น"
                    v-bind:items="levels"
                    v-bind:item-value="(item) => item.LEVEL_ID"
                    v-bind:item-text="
                      (item) => objectTranslator(item, 'LEVEL_NAME')
                    "
                    clearable
                    outlined
                    dense
                    @change="(e) => update_level(e)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete
                    v-model="year_id"
                    label="ปีการศึกษา"
                    v-bind:items="years"
                    v-bind:item-value="(item) => item.YEAR_ID"
                    v-bind:item-text="(item) => item.SEMESTER + '/' + item.YEAR"
                    clearable
                    outlined
                    dense
                    @change="(e) => update_year(e)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="round_id"
                    label="รอบ"
                    v-bind:items="rounds"
                    v-bind:item-value="(item) => item.ROUND_ID"
                    v-bind:item-text="(item) => objectTranslator(item, 'NAME')"
                    clearable
                    outlined
                    dense
                    @change="(e) => update_round(e)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="project_id"
                    label="โครงการ"
                    v-bind:items="projects"
                    v-bind:item-value="(item) => item.PROJECT_ID"
                    v-bind:item-text="
                      (item) => objectTranslator(item, 'PROJECT_NAME')
                    "
                    clearable
                    outlined
                    dense
                    @change="(e) => update_project(e)"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="curriculum_id"
                    label="หลักสูตร/สาขาวิชา"
                    v-bind:items="curriculums"
                    v-bind:item-value="(item) => item.CURRICULUM_ID"
                    v-bind:item-text="
                      (item) =>
                        objectTranslator(item, 'CURRICULUM_SHORT_NAME') +
                        ' | ประเภทรับเข้า : ' +
                        objectTranslator(item, 'STUDY_ADMIT_TYPE_NAME') +
                        ' => แผนการศึกษา : ' +
                        objectTranslator(item, 'STUDY_PLAN_NAME') +
                        ' | ช่วงเวลาเรียน : ' +
                        objectTranslator(item, 'STUDY_CLASSES_NAME') +
                        ' | เฉพาะสัญชาติ : ' +
                        objectTranslator(item, 'SPECIFIC_NATION_NAME')
                    "
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="!(project_id && curriculum_id)"
                color="indigo"
                class="ml-2 mb-5 white--text"
                @click="get_all_move_applicant_to()"
              >
                ยืนยันการย้ายเลขที่ผู้สมัคร
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog max-width="600" v-model="open_lock_confirm">
      <v-card>
        <v-card-title>ยืนยันการย้าย</v-card-title>
        <v-card-text>
          เลขที่ใบสมัคร : {{ register_id }}
          <br />
          {{ " จาก " + register_curriculum_name_order1 }}
          <span v-if="register_level_id != 1">{{
            register_curriculum_detail_order1
          }}</span>
          <br />
          <span class="red--text text--lighten-1"> ไปยัง </span>
          <br />
          ระดับ
          <span class="green--text text--lighten-1">
            {{ LEVEL_NAME_TO + " ปีการศึกษา " + YEAR_SEMESTER_TO }}
          </span>
          <br />
          รอบ
          <span class="green--text text--lighten-1">
            {{ ROUND_NAME_TO }}
          </span>
          <br />
          โครงการ
          <span class="green--text text--lighten-1">
            {{ PROJECT_NAME_TO }}
          </span>
          <br />
          หลักสูตร
          <span class="green--text text--lighten-1">
            {{ CURRICULUM_NAME_TO }}
          </span>
        </v-card-text>
        <v-card-actions>
          <v-btn dark color="green" @click="confirm_move_applicant(true)"
            >ยืนยัน</v-btn
          >
          <v-btn
            outlined
            color="red"
            class="ml-4"
            @click="(e) => (open_lock_confirm = false)"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";
import RefProvider from "@/services/ref.provider";
import PayInSlipProvider from "@/services/pay_in_slip.provider";
import AuthProvider from "@/services/auth.provider";
import { listFilter, getById } from "@/helper/filter";
const configProvider = new ConfigProvider();
const refProvider = new RefProvider();
const payInSlipService = new PayInSlipProvider();
const authProvider = new AuthProvider();

export default {
  name: "MoveApplicant",

  data: () => ({
    loading: false,
    register_id: null,
    register_uid: null,
    payment_confirm_fee: null,
    register_status_id: null,
    refused: null,
    register_project: null,
    register_round: null,
    register_level_id: null,
    register_level_name_th: null,
    register_level_name_en: null,
    register_curriculum: null,
    register_curriculum_name_order1: null,
    register_curriculum_name_order2: null,
    register_curriculum_name_order3: null,
    register_curriculum_detail_order1: null,
    register_curriculum_detail_order2: null,
    register_curriculum_detail_order3: null,
    open_lock_confirm: false,
    register_project_id_old: null,
    register_curriculum_id_old_order1: null,
    register_curriculum_id_old_order2: null,
    register_curriculum_id_old_order3: null,
    LEVEL_NAME_TO: null,
    YEAR_SEMESTER_TO: null,
    ROUND_NAME_TO: null,
    PROJECT_NAME_TO: null,
    CURRICULUM_NAME_TO: null,

    UserInfo_nameTh: null,
    UserInfo_surnameTh: null,
    email: null,
    mobile: null,
    citizen: null,

    level_id: 2,
    year_id: null,
    round_id: null,
    project_id: null,
    // faculty_id: null,
    curriculum_id: null,
    //-------------------------
    registerData: [],
    levels: [],
    years: [],
    rounds: [],
    projects: [],
    // faculties: [],
    curriculums: [],
    admissionStatus: [],

    curriculum_status: [
      {
        value: 1,
        name: "ผ่าน",
      },
      {
        value: 0,
        name: "ไม่ผ่าน",
      },
    ],
    order1_status: 0,
    order2_status: 0,
    order3_status: 0,

    admissionStatus_id: null,
    curriculum_all_status: [],
  }),

  methods: {
    objectTranslator,
    inlineTranslator,
    listFilter,
    getById,

    // filled_register_id() {
    //   this.get_register_details();
    // },

    async get_register_details() {
      this.loading = true;
      this.register_curriculum_name_order1 = null;
      this.register_curriculum_name_order2 = null;
      this.register_curriculum_name_order3 = null;
      this.register_curriculum_detail_order1 = null;
      this.register_curriculum_detail_order2 = null;
      this.register_curriculum_detail_order3 = null;
      this.register_curriculum_id_old_order1 = null;
      this.register_curriculum_id_old_order2 = null;
      this.register_curriculum_id_old_order3 = null;
      this.curriculum_all_status = [];

      const register_uid = await configProvider
        .getUIDbyRegisterID(parseInt(this.register_id))
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      this.register_uid = register_uid.UID;
      this.payment_confirm_fee = register_uid.PAYMENT_CONFIRM_FEE;
      this.register_status_id = register_uid.REGISTER_STATUS_ID;
      this.refused = register_uid.REFUSED;

      // const find_by_status = this.admissionStatus.filter((item) =>
      //   this.register_status_id.includes(item.STATUS)
      // );
      // const find_by_refuse = find_by_status.filter((item) =>
      //   this.refused.includes(item.REFUSE)
      // );
      this.admissionStatus_id = this.register_status_id + this.refused;
      const data = await authProvider.getUserInfo(this.register_uid);
      this.UserInfo_nameTh = data.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameTh = data.admission.STUDENT_LNAME_TH;
      this.mobile = data.admission.MOBILE;
      this.email = data.admission.EMAIL;
      this.citizen = data.admission.CITIZEN_ID;

      const registerData = await payInSlipService
        .getPaymentApplicationFee(parseInt(this.register_id))
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message));
        });
      // this.register = registerData.register_id;
      this.register_project = registerData.project_name_th;
      this.register_round = registerData.round_name_th;
      this.register_level_id = registerData.level_id;
      this.register_level_name_th = registerData.level_name_th;
      this.register_level_name_en = registerData.level_name_en;
      this.register_curriculum = registerData.register_curriculum;
      this.register_project_id_old = registerData.project_id;

      if (this.register_curriculum[0]) {
        this.register_curriculum_name_order1 = this.register_curriculum[0].curriculum_name_th;
        this.order1_status = parseInt(this.register_curriculum[0].passed);
        this.register_curriculum_id_old_order1 = this.register_curriculum[0].admission_curriculum_id;
        if (this.register_level_id != 1) {
          this.register_curriculum_detail_order1 =
            " => " +
            this.register_curriculum[0].study_plan_name_th +
            " | ประเภทรับเข้า : " +
            this.register_curriculum[0].study_admit_type_name_th +
            " | ช่วงเวลาเรียน : " +
            this.register_curriculum[0].study_classes_name_th +
            " | เฉพาะสัญชาติ : " +
            this.register_curriculum[0].specific_nation_name_th;
        }
        this.curriculum_all_status.push({
          ORDER: 1,
          ADMISSION_CURRICULUM_ID: this.register_curriculum[0]
            .admission_curriculum_id,
          PASSED: this.order1_status,
        });
      }
      if (this.register_curriculum[1]) {
        this.register_curriculum_name_order2 = this.register_curriculum[1].curriculum_name_th;
        this.order2_status = parseInt(this.register_curriculum[1].passed);
        this.register_curriculum_id_old_order2 = this.register_curriculum[1].admission_curriculum_id;
        if (this.register_level_id != 1) {
          this.register_curriculum_detail_order2 =
            " => " +
            this.register_curriculum[1].study_plan_name_th +
            " | ประเภทรับเข้า : " +
            this.register_curriculum[1].study_admit_type_name_th +
            " | ช่วงเวลาเรียน : " +
            this.register_curriculum[1].study_classes_name_th +
            " | เฉพาะสัญชาติ : " +
            this.register_curriculum[1].specific_nation_name_th;
        }
        this.curriculum_all_status.push({
          ORDER: 2,
          ADMISSION_CURRICULUM_ID: this.register_curriculum[1]
            .admission_curriculum_id,
          PASSED: this.order2_status,
        });
      }
      if (this.register_curriculum[2]) {
        this.register_curriculum_name_order3 = this.register_curriculum[2].curriculum_name_th;
        this.order3_status = parseInt(this.register_curriculum[2].passed);
        this.register_curriculum_id_old_order3 = this.register_curriculum[2].admission_curriculum_id;
        if (this.register_level_id != 1) {
          this.register_curriculum_detail_order3 =
            " => " +
            this.register_curriculum[2].study_plan_name_th +
            " | ประเภทรับเข้า : " +
            this.register_curriculum[2].study_admit_type_name_th +
            " | ช่วงเวลาเรียน : " +
            this.register_curriculum[2].study_classes_name_th +
            " | เฉพาะสัญชาติ : " +
            this.register_curriculum[2].specific_nation_name_th;
        }
        this.curriculum_all_status.push({
          ORDER: 3,
          ADMISSION_CURRICULUM_ID: this.register_curriculum[2]
            .admission_curriculum_id,
          PASSED: this.order3_status,
        });
      }
      this.loading = false;
    },

    async update_level(level_id) {
      this.year_id = null;
      const years = await configProvider.getYearByLevelIds(level_id);
      this.years = years;
      this.round_id = null;
      this.project_id = null;
      this.curriculum_id = null;
    },

    async update_year(year_id) {
      this.round_id = null;
      const rounds = await configProvider.getFilteredRounds(year_id);
      this.rounds = rounds.filter((item) => item.YEAR_ID === this.year_id);
      this.project_id = null;
      this.curriculum_id = null;
    },

    async update_round(year_id) {
      this.project_id = null;
      const projects = await configProvider.getFilteredProjects(year_id);
      this.projects = projects.filter(
        (item) => item.ROUND_ID === this.round_id
      );
      this.curriculum_id = null;
    },

    async update_project(year_id) {
      this.curriculum_id = null;
      const curriculums = await configProvider.getFilteredCurriculums(year_id);
      this.curriculums = curriculums.filter(
        (item) => item.PROJECT_ID === this.project_id
      );
    },

    async get_all_move_applicant_to() {
      const ref_data_level = getById(this.levels, this.level_id, "LEVEL_ID");
      this.LEVEL_NAME_TO = ref_data_level.LEVEL_NAME_TH;
      const ref_data_year_semester = getById(
        this.years,
        this.year_id,
        "YEAR_ID"
      );
      this.YEAR_SEMESTER_TO =
        ref_data_year_semester.SEMESTER + "/" + ref_data_year_semester.YEAR;
      const ref_data_round = getById(this.rounds, this.round_id, "ROUND_ID");
      this.ROUND_NAME_TO = ref_data_round.NAME_TH;
      const ref_data_project = getById(
        this.projects,
        this.project_id,
        "PROJECT_ID"
      );
      this.PROJECT_NAME_TO = ref_data_project.PROJECT_NAME_TH;

      const ref_data_curriculum = getById(
        this.curriculums,
        this.curriculum_id,
        "CURRICULUM_ID"
      );
      this.CURRICULUM_NAME_TO =
        ref_data_curriculum.CURRICULUM_SHORT_NAME_TH +
        " | ประเภทรับเข้า " +
        ref_data_curriculum.STUDY_ADMIT_TYPE_NAME_TH +
        " | " +
        ref_data_curriculum.STUDY_PLAN_NAME_TH +
        " | ช่วงเวลาเรียน : " +
        ref_data_curriculum.STUDY_CLASSES_NAME_TH +
        " | เฉพาะสัญชาติ " +
        ref_data_curriculum.SPECIFIC_NATION_NAME_TH;

      this.open_lock_confirm = true;
    },

    async confirm_move_applicant() {
      this.loading = true;
      const response = await configProvider.setMoveApplicant({
        REGISTER_ID: this.register_id,
        PROJECT_ID_OLD: this.register_project_id_old,
        PROJECT_ID_NEW: this.project_id,
        CURRICULUM_ID_OLD: this.register_curriculum_id_old_order1,
        CURRICULUM_ID_NEW: this.curriculum_id,
      });
      if (response.status) {
        this.$toasted.success("Update sucessfully");
      } else {
        this.$toasted.error("Update failed!!!!!!");
      }
      this.open_lock_confirm = false;
      this.years = null;
      this.rounds = null;
      this.projects = null;
      this.curriculums = null;
      this.get_register_details();
      this.loading = false;
    },

    async save_assertion_fee() {
      this.loading = true;
      const response = await payInSlipService
        .saveAssertionFee({
          REGISTER_ID: this.register_id,
          PAYMENT_CONFIRM_FEE: this.payment_confirm_fee,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response.status) {
        this.$toasted.success("Update sucessfully");
      }
      this.loading = false;
    },

    async save_status_curriculum_and_applicant() {
      const filter_status = this.admissionStatus.filter(
        (item) => item.STATUS + item.REFUSE === this.admissionStatus_id
      );
      const response = await payInSlipService
        .saveCurriculumAndApplicantStatus({
          REGISTER_ID: this.register_id,
          REGISTER_STATUS_ID: filter_status[0].STATUS,
          REFUSED: filter_status[0].REFUSE,
          register_curriculum: this.curriculum_all_status,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
      if (response.status) {
        this.$toasted.success("Update sucessfully");
      }
    },

    async init_data() {
      const levels = await refProvider.getLevel();
      this.levels = levels;

      const admissionStatus = await refProvider.getAdmissionStatusInfos();
      this.admissionStatus = admissionStatus;
    },
  },
  watch: {
    order1_status(val) {
      if (val === 1) {
        this.order2_status = 0;
        this.order3_status = 0;
      }
      this.curriculum_all_status[0].PASSED = val;
    },
    order2_status(val) {
      if (val === 1) {
        this.order1_status = 0;
        this.order3_status = 0;
      }
      this.curriculum_all_status[1].PASSED = val;
    },
    order3_status(val) {
      if (val === 1) {
        this.order1_status = 0;
        this.order2_status = 0;
      }
      this.curriculum_all_status[2].PASSED = val;
    },
  },
  mounted: function() {
    this.init_data();
  },
};
</script>

<style scoped>
.holder {
  border-width: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: white;
  padding: 6px;
  background-color: #004d40;
  color: white;
}
</style>
